import { render, staticRenderFns } from "./DeliveryZonesReport.vue?vue&type=template&id=5317ac2c&scoped=true"
import script from "./DeliveryZonesReport.vue?vue&type=script&lang=js"
export * from "./DeliveryZonesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317ac2c",
  null
  
)

export default component.exports